/**
* @author Camilo
* @since  08/11/2017
**/
export class LoginModel{
	constructor(public usuario:string, public clave:string, public empresa:string){
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Login/Login.model.ts